import { useEffect } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import {
    Analytics,
    Application,
    Attribute,
    Feature, 
    TestComponent, 
    TestPackage, 
    TestScenario, 
    Workspace, 
    TestAttributeValue, 
    List, 
    ValueList, 
    Defect, 
    TestExecution, 
    TestAcceptanceCriteria, 
    TestDataIntegration, 
    Setting, 
    Company, 
    People, 
    User, 
    UserGroup, 
    Oportunity, 
    Dashboard, 
    Integration, 
    IntegrationSetting, 
    Department, 
    TestAgent, 
    Opening,
    Vacancy,
    Resume,
    AccessRole,
    TalentSphereDashboard,
    WorkItem,
    Completation,
    Assistant
} from '../../pages';
import { MainDrawer } from '../../shared/components';
import { useDrawerContext } from '../../shared/contexts';
import { useTranslation } from 'react-i18next';
import { Demand } from '../../pages/workSphere/project/Project';
import AssistantAI from '../../shared/components/assisstantAI/AssistantAI';

export const AppRoutes: React.FC = () => {
    const { setDrawerOptions } = useDrawerContext();
    const { t } = useTranslation();

    useEffect(() => {
        setDrawerOptions([
            {
                icon: 'home_outlined', path: '', label: t('menu.corpsphere.corporate'),
                childrens: [
                    { icon: 'domain_outlined', path: '/corpsphere/company', label: t('menu.corpsphere.company'), childrens: [] },
                    { icon: 'people_outlined', path: '/corpsphere/people', label: t('menu.corpsphere.people'), childrens: [] },
                    { icon: 'reduce_capacity_outlined', path: '/corpsphere/department', label: t('menu.corpsphere.department'), childrens: [] },
                ],
                IconColor: 'primary'
            },
            {
                icon: 'people_outlined', path: '', label: t('menu.talentSphere.talentSphere'),
                childrens: [
                    // { icon: 'insert_chart_outlined', path: '/talentsphere/dashboard', label: t('menu.talentSphere.dashboard'), childrens: [] },
                    { icon: 'people_outlined', path: '/talentsphere/resume', label: t('menu.talentSphere.resume'), childrens: [] },
                    { icon: 'person_add_outlined', path: '/talentsphere/vacancy', label: t('menu.talentSphere.vacancy'), childrens: [] },
                    // { icon: 'assignment_ind_outlined', path: '/corpsphere/people', label: t('menu.talentSphere.employee'), childrens: [] },
                ],
                IconColor: 'secondary'
            },
            {
                icon: 'settings_outlined', path: '', label: t('menu.administrative'),
                childrens: [
                    { icon: 'manage_accounts_outlined', path: '/authsphere/user', label: t('menu.authSphere.user'), childrens: [] },
                    { icon: 'group_outlined', path: '/authsphere/usergroup', label: t('menu.authSphere.userGroup'), childrens: [] },
                    { icon: 'manage_accounts_outlined', path: '/authsphere/accessRole', label: t('menu.authSphere.accessRole'), childrens: [] },
                    { icon: 'list_alt_outlined', path: '/parmsphere/list', label: t('menu.parmSphere.list'), childrens: [] },
                    // { icon: 'list_outlined', path: '/parmsphere/valueList', label: t('menu.parmSphere.valueList'), childrens: [] },
                    { icon: 'tune_outlined', path: '/parmsphere/setting', label: t('menu.parmSphere.setting'), childrens: [] },
                    { icon: 'grid_view_outlined', path: '/appsphere/application', label: t('menu.appSphere.application'), childrens: [] },
                ],
                IconColor: 'secondary'
            },
            
            //bizsphere
            
            // {
            //     icon: 'dashboard', path: '', label: t('menu.dashsphere.dashboard'),
            //     childrens: [
            //         { icon: 'dashboard', path: '/dashboard', label: t('menu.dashsphere.dashboard') },
            //     ],
            //     IconColor: 'primary'
            // },
            // { icon: '', path: '', label: 'divider', childrens: [] },
            // {
            //     icon: 'work_outlined', path: '', label: 'WorkSphere',
            //     childrens: [
            //         { icon: 'list_alt_outlined', path: '/worksphere/project', label: 'Project', childrens: [] },
            //         { icon: 'task_outlined', path: '/worksphere/workItem', label: 'Work Item', childrens: [] },
            //         { icon: 'task_outlined', path: '/worksphere/sprint', label: 'Sprint', childrens: [] },
            //     ],
            //     IconColor: 'secondary'
            // },
            // {
            //     icon: 'home_outlined', path: '', label: 'CorpSphere',
            //     childrens: [
            //         { icon: 'domain_outlined', path: '/corpsphere/company', label: 'Company', childrens: [] },
            //         { icon: 'people_outlined', path: '/corpsphere/people', label: 'People', childrens: [] },
            //         { icon: 'reduce_capacity_outlined', path: '/corpsphere/department', label: 'Department', childrens: [] },
            //         { icon: 'group_outlined', path: '/corpsphere/opening', label: 'Opening', childrens: [] },
            //     ],
            //     IconColor: 'info'
            // },
            // {
            //     icon: 'recommend_outlined', path: '', label: 'ClientSphere',
            //     childrens: [
            //         { icon: 'domain_outlined', path: '/clientsphere/oportunity', label: 'Oportunity', childrens: [] },
            //         { icon: 'gavel_outlined', path: '/clientsphere/proposal', label: 'Proposal', childrens: [] },
            //     ],
            //     IconColor: 'primary'
            // },
            // {
            //     icon: 'people_outlined', path: '', label: 'TalentSphere',
            //     childrens: [
            //         { icon: 'person_outlined', path: '/talentsphere/resume', label: 'Resume', childrens: [] },
            //         { icon: 'person_add_outlined', path: '/talentsphere/vacancy', label: 'Vacancy', childrens: [] },
            //     ],
            //     IconColor: 'warning'
            // },
            // {
            //     icon: 'apps_outlined', path: '', label: 'AppSphere',
            //     childrens: [
            //         { icon: 'grid_view_outlined', path: '/appsphere/application', label: 'Application', childrens: [] },
            //     ],
            //     IconColor: 'info'
            // },
            // {
            //     icon: 'verified_user_outlined', path: '', label: 'TestingSphere',
            //     childrens: [
            //         { icon: 'workspaces_outlined', path: '/testingsphere/workspace', label: 'Workspace', childrens: [] },
            //         { icon: 'rule_folder_outlined', path: '/testingsphere/testpackage', label: 'TestPackage', childrens: [] },
            //         { icon: 'bug_report_outlined', path: '/testingsphere/defect', label: 'Defect', childrens: [] },
            //         { icon: 'engineering_outlined', path: '/testingsphere/testagent', label: 'TestAgent', childrens: [] },
            //     ],
            //     IconColor: 'success'
            // },
            // {
            //     icon: 'link_outlined', path: '', label: 'LinkSphere',
            //     childrens: [
            //         { icon: 'integration_instructions_outlined', path: '/linkSphere/integration', label: 'Integration', childrens: [] },
            //         { icon: 'settings_outlined', path: '/linkSphere/integrationSetting', label: 'Integration Setting', childrens: [] },
            //     ],
            //     IconColor: 'info'
            // },
            // {
            //     icon: 'settings_outlined', path: '', label: 'ParamSphere',
            //     childrens: [
            //         { icon: 'list_alt_outlined', path: '/parmsphere/list', label: 'List', childrens: [] },
            //         { icon: 'list_outlined', path: '/parmsphere/valueList', label: 'List Value', childrens: [] },
            //         { icon: 'tune_outlined', path: '/parmsphere/setting', label: 'Setting', childrens: [] },
            //     ],
            //     IconColor: 'error'
            // },
            // {
            //     icon: 'admin_panel_settings_outlined', path: '', label: 'AuthSphere',
            //     childrens: [
            //         { icon: 'manage_accounts_outlined', path: '/authsphere/user', label: 'User', childrens: [] },
            //         { icon: 'group_outlined', path: '/authsphere/usergroup', label: 'UserGroup', childrens: [] },
            //         { icon: 'rule_outlined', path: '/authsphere/accessRole', label: 'Access Role', childrens: [] },
            //     ],
            //     IconColor: 'primary'
            // }
        ]);
    }, []);

    return (

        <MainDrawer
            title=''
        >
            <Routes>
                {/* company */}
                <Route path='/corpsphere/company' element={<Company />} />
                <Route path='/corpsphere/people' element={<People data={''} />} />
                <Route path='/corpsphere/department' element={<Department />} />
                <Route path='/corpsphere/opening' element={<Opening />} />

                {/* talentsphere */}
                <Route path='/talentsphere/dashboard' element={<TalentSphereDashboard />} />
                <Route path='/talentsphere/resume' element={<Resume data={''} />} />
                <Route path='/talentsphere/vacancy' element={<Vacancy />} />

                {/* authssphere */}
                <Route path='/authsphere/user' element={<User />} />
                <Route path='/authsphere/userGroup' element={<UserGroup />} />
                <Route path='/authsphere/accessRole' element={<AccessRole />} />

                {/* clientsphere */}
                <Route path='/clientsphere/oportunity' element={<Oportunity />} />

                {/* worksphere */}
                <Route path='/worksphere/project' element={<Demand />} />
                <Route path='/worksphere/workItem' element={<WorkItem data={''} />} />

                {/* dashboardsphere */}
                <Route path='/dashboard' element={<Dashboard />} />
                <Route path='/analytics' element={<Analytics />} />

                {/* testingsphere */}
                <Route path='/testingsphere/workspace' element={<Workspace />} />
                <Route path='/testingsphere/testpackage' element={<TestPackage data={''} />} />
                <Route path='/testingsphere/testscenario' element={<TestScenario data={''} />} />
                <Route path='/testingsphere/testcomponent' element={<TestComponent data={''} />} />
                <Route path='/testingsphere/testattributevalue' element={<TestAttributeValue data={''} />} />
                <Route path='/testingsphere/testexecution' element={<TestExecution data={''} />} />
                <Route path='/testingsphere/testacceptancecriteria' element={<TestAcceptanceCriteria data={''} />} />
                <Route path='/testingsphere/testdataintegration' element={<TestDataIntegration data={''} />} />
                <Route path='/testingsphere/defect' element={<Defect />} />
                <Route path='/testingsphere/testagent' element={<TestAgent />} />

                {/* appsphere */}
                <Route path='/appsphere/application' element={<Application />} />
                <Route path='/appsphere/feature' element={<Feature data={''} />} />
                <Route path='/appsphere/attribute' element={<Attribute data={''} />} />

                {/* parsphere */}
                <Route path='/parmsphere/list' element={<List />} />
                <Route path='/parmsphere/valuelist' element={<ValueList data={''} />} />
                <Route path='/parmsphere/setting' element={<Setting />} />

                {/* linksphere */}
                <Route path='/linksphere/integration' element={<Integration />} />
                <Route path='/linksphere/integrationSetting' element={<IntegrationSetting />} />
                
                {/* aisphere */}
                <Route path='/aisphere/assistant' element={<Assistant />} />
                <Route path='/aisphere/completion' element={<Completation />} />
                
                <Route path='*' element={<Navigate to='/dashboard' />} />
            </Routes>
        </MainDrawer>
    );
};
